let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("aBH2w")]).then(() => parcelRequire('8nrlS'));